import React from "react";
import T from "prop-types";
import { shortDateAndTimestamp } from "LIB/formatters/date";

const UpdatedTrackedFieldsAt = ({
  record,
  formatter = shortDateAndTimestamp
}) => (
  <span className={record.updated_tracked_fields_at && "text-yellow"}>
    {formatter(record.updated_tracked_fields_at || record.created_at)}
  </span>
);

UpdatedTrackedFieldsAt.propTypes = {
  formatter: T.func,
  record: T.shape({})
};

export default UpdatedTrackedFieldsAt;



// WEBPACK FOOTER //
// ./app/modules/shared/components/UpdatedTrackedFieldsAt/UpdatedTrackedFieldsAt.jsx